(function(exports) {
	const DEFAULT_PROGRAM_COUNT_MAX = 3;

	class TransferableDetails {
		constructor(options) {
			this.programList = options.programList;
		}
	}

	class ProgramListComponent {
		constructor(params) {
			let self = this;
			let programList = params.programList;

			self.programs = {
				showAll: ko.observable(false),
				moreCount: programList.length - DEFAULT_PROGRAM_COUNT_MAX,
				programsTerm: params.programsTerm
			};

			self.programs.toggleShowAll = function() {
				self.programs.showAll(!self.programs.showAll());
			};

			self.programs.list = ko.computed(function() {
				if (self.programs.showAll()) {
					return programList;
				}

				return programList.slice(0, DEFAULT_PROGRAM_COUNT_MAX);
			});
		}

		
		static createDefaultTemplate() {
			if (document.getElementById("ProgramListTemplate")) {
				return {
					element: "ProgramListTemplate"
				};
			}

			return `
<div class="applicable-course-list page-section" data-bind="with: programs">
	<h3>Applicable <span data-bind="text: programsTerm"></span></h3>
	<ul data-bind="foreach: list">
		<li>
			<div data-bind="programName: $data"></div>
		</li>
	</ul>
	<!-- ko if: moreCount > 0 -->
	<div class="collapse-box">
		<a href="javascript:void(0)" data-bind="click: toggleShowAll">
			<!-- ko if: showAll -->
			Collapse
			<span class="glyphicon glyphicon-triangle-top"></span>
			<!-- /ko -->
			<!-- ko ifnot: showAll -->
			<span data-bind="text: moreCount"></span> other(s). Show all
			<span class="glyphicon glyphicon-triangle-bottom"></span>
			<!-- /ko -->
		</a>
	</div>
	<!-- /ko -->	
</div>`;
		}
	}

	ko.components.register("program-list", {
		viewModel: ProgramListComponent,
		template: ProgramListComponent.createDefaultTemplate(),
		synchronous: true
	});

	exports.Modeler = exports.Modeler || {};
	exports.Modeler.TransferableDetails = TransferableDetails;
	exports.Modeler.Components = exports.Modeler.Components || {};
	exports.Modeler.Components.ProgramList = ProgramListComponent;
})(window.App = window.App || {});